/*
 * Gateway real del probador (Fase B). Envuelve el gateway que haya (el mock en A1) y sustituye SOLO las operaciones del
 * probador por llamadas al App Proxy (/apps/normcore-tryon/...). El resto sigue en el mock hasta que exista su backend.
 * Mismo contrato que nc-gateway-mock.js: getTryOnConfig, get/setTryOnConsent, createUpload (purpose 'avatar'),
 * validateAvatar, deleteAvatar, requestLookRender, getLookRender. Activar: window.NcGatewayTryon.wrap(gateway).
 */
(function (root) {
  var BASE = '/apps/normcore-tryon';
  var SEEN_KEY = 'nc-signed-in';
  // Backend failure -> the error the rest of the theme reads (the mock's shape): kind + fieldErrors next to the server's code/fields/status.
  // 401 = unauthenticated, 403 = forbidden (consent), 422 = validation (the daily quota arrives as fields.quota), 5xx = server, no answer = network.
  function kindFor(status) {
    if (status === 401) return 'unauthenticated';
    if (status === 403) return 'forbidden';
    if (status === 422) return 'validation';
    if (status >= 500) return 'server';
    return status ? 'unknown' : 'network';
  }
  function errorFor(status, data) {
    var body = (data && data.error) || {};
    var e = new Error(body.message || 'Error del probador');
    e.status = status; e.code = body.code; e.fields = body.fields;
    e.kind = kindFor(status);
    e.fieldErrors = body.fields || {};
    if (e.kind === 'network' || e.kind === 'server') e.retryable = true;
    return e;
  }
  function networkError(err) { var e = errorFor(0, null); e.message = (err && err.message) || e.message; e.name = err && err.name; return e; }
  // Who is looking, painted by Liquid on <body data-nc-auth="in|out"> (layout/theme.liquid). `in` remembers it on this device so that a later
  // `out` reads as "your session ended" (expired) and not as "you never signed in" (anonymous).
  function authFromPage(inner) {
    var doc = typeof document !== 'undefined' ? document : null, attr = doc && doc.body && doc.body.getAttribute('data-nc-auth');
    var store = null; try { store = root.localStorage; } catch (e) { store = null; }
    if (attr !== 'in' && attr !== 'out') return inner.getAuthState ? inner.getAuthState() : Promise.resolve({ status: 'anonymous' });
    if (attr === 'in') {
      try { if (store) store.setItem(SEEN_KEY, '1'); } catch (e) { /* private mode */ }
      // a review scenario of the mock (?nc-scenario=expired) may still say otherwise
      return (inner.getAuthState ? inner.getAuthState() : Promise.resolve(null)).then(function (a) {
        if (a && a.status && a.status !== 'authenticated') return a;
        return { status: 'authenticated', userId: (doc.body.getAttribute('data-nc-customer-id') || (a && a.userId) || ''), name: doc.body.getAttribute('data-nc-customer-name') || '', permissions: (a && a.permissions) || ['read', 'write'] };
      }, function () { return { status: 'authenticated' }; });
    }
    var seen = false; try { seen = !!(store && store.getItem(SEEN_KEY)); } catch (e) { seen = false; }
    return Promise.resolve({ status: seen ? 'expired' : 'anonymous' });
  }
  // true only when the page itself says nobody is signed in (no DOM or no attribute = unknown, requests go out as before)
  function isVisitor() { return typeof document !== 'undefined' && !!document.body && document.body.getAttribute('data-nc-auth') === 'out'; }
  // signed in: the person is the Shopify customer (first name painted on <body>), never the mock's «Aura». The example looks, garments and
  // counters of the mock are not theirs, so the profile starts honestly empty until a backend holds their own (Bloque 4).
  function isMember() { return typeof document !== 'undefined' && !!document.body && document.body.getAttribute('data-nc-auth') === 'in'; }
  function me() {
    var b = document.body;
    return { id: b.getAttribute('data-nc-customer-id') || 'me', displayName: b.getAttribute('data-nc-customer-name') || 'Tu perfil', handle: '', location: '', bio: '', avatarAssetId: null };
  }
  // Fase B (docs/normcore-fase-b-plan.md): favoritos y datos de cuenta viven en el backend SOLO si /config dice features.favorites / features.account
  // (por defecto apagado) y la persona tiene sesión. Si no, todo sigue donde estaba (el gateway de dentro), así tema y backend se despliegan en cualquier orden.
  var featuresPromise = null;
  function features() {
    if (!featuresPromise) featuresPromise = call('GET', '/config').then(function (c) { return (c && c.features) || {}; }, function () { return {}; });
    return featuresPromise;
  }
  function noticesMock() { try { return /[?&]nc-notices=mock(&|$)/.test(root.location.search); } catch (e) { return false; } }
  // looks guardados en servidor (QA 2026-10-31): /config features.lookFavorites (FEATURE_LOOK_FAVORITES) además de favorites y sesión; si no, siguen locales
  function useLookBackend() { return !isMember() ? Promise.resolve(false) : features().then(function (f) { return !!(f.favorites && f.lookFavorites); }); }
  function useBackend(name) { return !isMember() ? Promise.resolve(false) : features().then(function (f) { return !!f[name]; }); }
  // D-F1: the first time the backend favourites are on for this customer, the garments saved on this device are sent once (store products only: the mock's examples are not theirs)
  function migrateLocalFavorites(inner) {
    var key = 'nc-fav-migrated:' + ((typeof document !== 'undefined' && document.body && document.body.getAttribute('data-nc-customer-id')) || 'me'), store = null;
    try { store = root.localStorage; } catch (e) { store = null; }
    try { if (store && store.getItem(key)) return Promise.resolve(); } catch (e) { /* private mode */ }
    return (inner.listFavorites ? inner.listFavorites({ kind: 'product', page: 1 }) : Promise.resolve({ items: [] })).then(function (r) {
      var ids = ((r && r.items) || []).map(function (p) { return p && p.id; }).filter(function (id) { return /^store-\d+$/.test(String(id)); });
      return ids.reduce(function (chain, id) { return chain.then(function () { return call('POST', '/favorites', { kind: 'product', id: bareId(id), value: true }); }); }, Promise.resolve());
    }).then(function () { try { if (store) store.setItem(key, '1'); } catch (e) { /* private mode */ } }, function () { /* tried again next time */ });
  }
  // 'store-123' (tema) <-> '123' (Shopify)
  function bareId(id) { return String(id).replace(/^store-/, ''); }
  function themeId(id) { return /^\d+$/.test(String(id)) ? 'store-' + id : String(id); }
  function call(method, path, body, isForm) {
    var opts = { method: method, credentials: 'same-origin', headers: {} };
    if (body && !isForm) { opts.headers['content-type'] = 'application/json'; opts.body = JSON.stringify(body); }
    if (body && isForm) opts.body = body;
    // marking a notice read or deleting it can happen as the page goes away: keepalive lets the request outlive the page that sent it
    if (method !== 'GET' && path.indexOf('/notifications') === 0) opts.keepalive = true;
    return fetch(BASE + path, opts).then(function (r) {
      if (r.status === 204) return null;
      return r.json().then(function (data) {
        if (!r.ok) throw errorFor(r.status, data);
        return data;
      }, function (err) { if (!r.ok) throw errorFor(r.status, null); throw networkError(err); });
    }, function (err) { throw networkError(err); });
  }
  // Reduce la foto a 1536 px de lado mayor antes de subirla (menos bytes por el proxy; el modelo no necesita más)
  function shrink(file) {
    if (!/^image\//.test(file.type) || typeof createImageBitmap !== 'function') return Promise.resolve(file);
    return createImageBitmap(file).then(function (bmp) {
      var max = 1536, s = Math.min(1, max / Math.max(bmp.width, bmp.height));
      if (s === 1) return file;
      var cv = document.createElement('canvas'); cv.width = Math.round(bmp.width * s); cv.height = Math.round(bmp.height * s);
      cv.getContext('2d').drawImage(bmp, 0, 0, cv.width, cv.height);
      return new Promise(function (res) { cv.toBlob(function (b) { res(new File([b], 'avatar', { type: 'image/jpeg' })); }, 'image/jpeg', 0.9); });
    }).catch(function () {
      // F7: the browser could not decode it: only a file that no <img> can show either is refused (a JPEG variant the bitmap API dislikes still goes up)
      return new Promise(function (res) {
        var url = URL.createObjectURL(file), im = new Image();
        im.onload = function () { URL.revokeObjectURL(url); res(file); };
        im.onerror = function () { URL.revokeObjectURL(url); var e = new Error('unreadable'); e.kind = 'validation'; e.code = 'unreadable'; e.fieldErrors = {}; res(Promise.reject(e)); };
        im.src = url;
      });
    });
  }
  // The backend asks the model for the person on a flat magenta (#FF00FF) background. Magenta is keyed out everywhere, not only
  // where it touches the border: the gaps between an arm and the torso are enclosed and still carry the background colour.
  // Strong magenta becomes transparent; a 2 px band around it loses the magenta tint (the anti-aliased fringe) and fades out.
  // Garments in pure magenta would lose those pixels too, an accepted trade-off. RGBA array in, same array out.
  function keyOut(data, w, h) {
    var n = w * h, hit = new Uint8Array(n), near = new Uint8Array(n), i, x, y, d;
    function strong(j) { var k = j * 4, r = data[k], g = data[k + 1], b = data[k + 2]; return Math.min(r, b) - g > 70 && Math.abs(r - b) < 90; }
    for (i = 0; i < n; i++) if (strong(i)) hit[i] = 1;
    for (i = 0; i < n; i++) if (hit[i]) {
      var px = i % w, py = (i - px) / w;
      for (y = Math.max(0, py - 2); y <= Math.min(h - 1, py + 2); y++) for (x = Math.max(0, px - 2); x <= Math.min(w - 1, px + 2); x++) near[y * w + x] = 1;
    }
    for (i = 0; i < n; i++) {
      d = i * 4;
      if (hit[i]) { data[d + 3] = 0; continue; }
      if (!near[i]) continue;
      var m = (Math.min(data[d], data[d + 2]) - data[d + 1]) / 255;
      if (m <= 0.1) continue;
      var spill = Math.max(0, (data[d] + data[d + 2]) / 2 - data[d + 1]) * 0.8;
      data[d] = Math.max(0, data[d] - spill); data[d + 2] = Math.max(0, data[d + 2] - spill);
      data[d + 3] = Math.round(255 * (1 - Math.min(1, Math.max(0, (m - 0.2) / 0.4))));
    }
    return data;
  }
  // image URL -> object URL of the same image with the magenta background keyed out; the original URL when the browser cannot do it.
  // Decoded through an <img> (same cookies and cache as the stage's own <img>, same-origin so the canvas is not tainted) rather than
  // fetch + createImageBitmap: a blob served as octet-stream or an auth redirect made that path fail silently and the raw image showed.
  function cutout(url) {
    if (typeof document === 'undefined') return Promise.resolve(url);
    return new Promise(function (res) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        try {
          var cv = document.createElement('canvas'); cv.width = img.naturalWidth; cv.height = img.naturalHeight;
          var ctx = cv.getContext('2d'); ctx.drawImage(img, 0, 0);
          var px = ctx.getImageData(0, 0, cv.width, cv.height); keyOut(px.data, cv.width, cv.height); ctx.putImageData(px, 0, 0);
          cv.toBlob(function (b) { res(b ? URL.createObjectURL(b) : url); }, 'image/png');
        } catch (e) { if (root.console) console.warn('nc-tryon: no se pudo recortar el fondo', e); res(url); }
      };
      img.onerror = function () { if (root.console) console.warn('nc-tryon: no se pudo cargar el render para recortarlo', url); res(url); };
      img.src = url;
    });
  }
  function wrap(gw) {
    var inner = gw;
    var rendered = {}; // assetId -> image URL of the renders seen in this page
    // own looks (ready renders) as profile cards; the id is the generated look's, which getLook below resolves for /pages/look?id=
    // a readable default name for a look made here: «Look de <primera prenda> + N» (no brand, no price); the date is the fallback when no garment is known
    function lookName(first, count, fallback) {
      var t = String(first || '').trim();
      if (!t) return fallback;
      if (t.length > 30) t = t.slice(0, 29).trim() + '…';
      return 'Look de ' + t + (count > 1 ? ' + ' + (count - 1) : '');
    }
    function lookDate(at) { var d = new Date(at || Date.now()); return isNaN(d) ? '' : d.toISOString().slice(0, 10); }
    function ownLooks() {
      return real.listGeneratedLooks().then(function (r) {
        return ((r && r.items) || []).filter(function (g) { return g && g.status === 'ready' && g.assetId; }).map(function (g) {
          return { id: g.id, title: lookName(g.items && g.items[0] && g.items[0].title, (g.items || []).length, 'Look del ' + lookDate(g.createdAt)), author: '', likes: 0, liked: false, saved: false, tags: [], assetId: g.assetId, garmentCount: (g.items || []).length, createdAt: new Date(g.createdAt || Date.now()).toISOString(), aiGenerated: true };
        });
      }, function () { return []; });
    }
    function ownGarments(pg) {
      return real.listFavorites({ kind: 'product', page: pg }).then(function (r) {
        return { items: ((r && r.items) || []).map(function (p) { return Object.assign({}, p, { favorite: true }); }), page: pg, pageSize: (r && r.pageSize) || 12, total: (r && r.total) || 0 };
      }, function () { return { items: [], page: pg, pageSize: 12, total: 0 }; });
    }
    function setLookOnServer(id, value, payload) {
      return useLookBackend().then(function (on) {
        if (!on) return null;
        var body = { kind: 'look', id: String(id), value: !!value };
        if (payload) body.payload = payload;
        return call('POST', '/favorites', body).then(function () { return null; });
      });
    }
    // D-F1 for looks: the salon looks saved on this device go up once (the mock's seeded examples are not theirs)
    function migrateLocalLooks() {
      var key = 'nc-look-fav-migrated:' + ((typeof document !== 'undefined' && document.body && document.body.getAttribute('data-nc-customer-id')) || 'me'), store = null;
      try { store = root.localStorage; } catch (e) { store = null; }
      try { if (store && store.getItem(key)) return Promise.resolve(); } catch (e) { /* private mode */ }
      return inner.listFavorites({ kind: 'look', page: 1 }).then(function (r) {
        var salon = ((r && r.items) || []).filter(function (l) { return l && l.source === 'salon' && l.productIds && l.productIds.length; });
        return salon.reduce(function (chain, l) {
          return chain.then(function () { return call('POST', '/favorites', { kind: 'look', id: l.id, value: true, payload: { title: l.title, productIds: l.productIds, savedAt: l.savedAt } }); });
        }, Promise.resolve());
      }).then(function () { try { if (store) store.setItem(key, '1'); } catch (e) { /* private mode */ } }, function () { /* tried again next time */ });
    }
    function lookFromServer(f) {
      var p = f.payload || {};
      // rows saved before the server fix carry the payload as a JSON string
      if (typeof p === 'string') { try { p = JSON.parse(p) || {}; } catch (e) { p = {}; } }
      var ids = (p.productIds || []).map(themeId);
      if (!ids.length) { // a community look saved by id: its card comes from the look record
        return (inner.getLook ? inner.getLook(f.id).catch(function () { return null; }) : Promise.resolve(null)).then(function (l) {
          return l && l.title ? { id: f.id, title: l.title, author: l.author || '', likes: l.likes || 0, liked: !!l.liked, saved: true, tags: l.tags || [], assetId: l.assetId || null, garmentCount: l.garmentCount || 0, createdAt: l.createdAt || null, aiGenerated: !!l.aiGenerated } : null;
        });
      }
      return (inner.getProduct ? inner.getProduct(ids[0]).catch(function () { return null; }) : Promise.resolve(null)).then(function (first) {
        return { id: f.id, title: p.title || 'Look guardado', author: '', likes: 0, liked: false, saved: true, tags: [], assetId: first ? first.assetId : null, garmentCount: ids.length, createdAt: null, savedAt: p.savedAt || Date.parse(f.createdAt) || 0, aiGenerated: false, source: 'salon', productIds: ids };
      });
    }
    function serverLooks(input) {
      return migrateLocalLooks().then(function () { return call('GET', '/favorites'); }).then(function (r) {
        var rows = ((r && r.favorites) || []).filter(function (x) { return x.kind === 'look'; });
        return Promise.all(rows.map(lookFromServer)).then(function (list) {
          var items = list.filter(Boolean), size = 12, pg = Math.max(1, (input && input.page) || 1);
          return { items: items.slice((pg - 1) * size, pg * size), page: pg, pageSize: size, total: items.length };
        });
      });
    }
    var real = {
      getTryOnConfig: function () { return call('GET', '/config'); },
      getTryOnConsent: function () { return call('GET', '/consent'); },
      setTryOnConsent: function (input) { return call('POST', '/consent', input); },
      createUpload: function (input) {
        if (!input || input.purpose !== 'avatar') return inner.createUpload(input);
        // a photo upload that does not answer in 45 s (a slow mobile network or a cold backend) is tried once more before the person sees an error
        return shrink(input.file).then(function (f) {
          var send = function () {
            var fd = new FormData(); fd.append('file', f, f.name);
            var ac = typeof AbortController === 'function' ? new AbortController() : null;
            var timer = ac ? setTimeout(function () { ac.abort(); }, 45000) : null;
            return fetch(BASE + '/avatars', { method: 'POST', credentials: 'same-origin', body: fd, signal: ac ? ac.signal : undefined }).then(function (r) {
              if (timer) clearTimeout(timer);
              return r.json().then(function (data) { if (!r.ok) throw errorFor(r.status, data); return data; }, function () { throw errorFor(r.status, null); });
            }, function (err) { if (timer) clearTimeout(timer); throw err; });
          };
          return send().catch(function (err) { if (err && (err.name === 'AbortError' || err.name === 'TypeError')) return send(); throw err; }).catch(function (err) { throw err && err.kind ? err : networkError(err); });
        });
      },
      // B1 / DP-2: the photo the customer chose to keep (GET /avatar) and the opt-in itself (POST /avatars/:id/retain). A backend that does not
      // have the routes yet (404) or a missing session answers like "nothing saved", never an error the person sees.
      getAuthState: function () { return authFromPage(inner); },
      getProfile: function () { return isMember() ? Promise.resolve(me()) : (inner.getProfile ? inner.getProfile() : Promise.resolve(null)); },
      // signed in: the profile shows what is theirs, read from the same sources as Mis favoritos and Historial (garments: listFavorites, looks:
      // listGeneratedLooks = GET /renders + this session); never the mock's examples, never an empty state while those lists have data
      getProfileDashboard: function () {
        if (!isMember()) return inner.getProfileDashboard();
        return Promise.all([ownLooks(), ownGarments(1)]).then(function (r) {
          return { profile: me(), metrics: [{ label: 'Looks', value: r[0].length }, { label: 'Prendas guardadas', value: r[1].total }], looks: r[0].slice(0, 4), garments: r[1].items.slice(0, 4), collections: [] };
        });
      },
      getProfileSection: function (input) {
        if (!isMember()) return inner.getProfileSection(input);
        var pg = Math.max(1, (input && input.page) || 1), size = 12;
        if (input && input.section === 'garments') return ownGarments(pg);
        if (input && input.section === 'looks') return ownLooks().then(function (l) { return { items: l.slice((pg - 1) * size, pg * size), page: pg, pageSize: size, total: l.length }; });
        return Promise.resolve({ items: [], page: 1, pageSize: size, total: 0 });
      },
      getSavedAvatar: function () { if (isVisitor()) return Promise.resolve({ avatar: null }); return call('GET', '/avatar').then(function (r) { return { avatar: (r && r.avatar) || null, days: r && r.days }; }, function () { return { avatar: null }; }); },
      retainAvatar: function (id, retain) { return call('POST', '/avatars/' + encodeURIComponent(id) + '/retain', { retain: !!retain }); },
      // B2: "avísame por email" for one look being made (needs the backend's email provider; getTryOnConfig().emailNotify says so)
      notifyByEmail: function (renderId, on) { return call('POST', '/renders/' + encodeURIComponent(renderId) + '/notify', { email: !!on }); },
      validateAvatar: function (id) { return call('POST', '/avatars/' + encodeURIComponent(id) + '/validate'); },
      deleteAvatar: function (id) { return call('DELETE', '/avatars/' + encodeURIComponent(id)); },
      // the theme's store products are 'store-<shopify id>' (nc-store-product-json); the backend wants the bare Shopify product id
      requestLookRender: function (input) {
        var body = Object.assign({}, input);
        if (Array.isArray(body.productIds)) body.productIds = body.productIds.map(function (id) { return String(id).replace(/^store-/, ''); });
        return call('POST', '/renders', body);
      },
      // vista de espalda (31-10-2026, FEATURE_BACK_VIEW): a second image of the same ready look, made on demand, free of the daily quota.
      // Both calls answer the back's own view model { status: none|queued|processing|ready|failed|blocked, assetId?, imageSrc? }.
      requestLookBack: function (renderId) {
        return call('POST', '/renders/' + encodeURIComponent(renderId) + '/back').then(function (b) {
          if (b && b.assetId && b.imageSrc) rendered[b.assetId] = b.imageSrc;
          return b;
        });
      },
      getLookBack: function (renderId) {
        return call('GET', '/renders/' + encodeURIComponent(renderId)).then(function (vm) {
          var b = (vm && vm.back) || { status: 'none' };
          if (b.assetId && b.imageSrc) rendered[b.assetId] = b.imageSrc;
          return b;
        });
      },
      // a ready render carries its image as `imageSrc`; the room asks for it later through getAsset(assetId), so remember the pair
      getLookRender: function (id) {
        return call('GET', '/renders/' + encodeURIComponent(id)).then(function (vm) {
          if (vm && vm.assetId && vm.imageSrc) rendered[vm.assetId] = vm.imageSrc;
          return vm;
        });
      },
      // Historial en servidor (DP-8, B5): los looks listos de los últimos días del cliente (GET /renders) se unen a los locales de la sesión;
      // los que solo están en el servidor se reconstruyen con las prendas que la página conoce. Así la galería «Mis looks» sobrevive a
      // cerrar el navegador y la imagen de un render real vuelve a estar disponible tras recargar. Un fallo (sin sesión, red) deja solo los locales.
      listGeneratedLooks: function () {
        var local = inner.listGeneratedLooks ? inner.listGeneratedLooks() : Promise.resolve({ items: [] });
        // a visitor has no history on the server: no request is made without a session
        var remoteCall = isVisitor() ? Promise.resolve(null) : call('GET', '/renders').catch(function () { return null; });
        return Promise.all([local, remoteCall]).then(function (res) {
          var items = ((res[0] && res[0].items) || []).slice(), remote = res[1] && res[1].looks;
          if (!remote || !remote.length) return { items: items };
          var byRender = {};
          items.forEach(function (r) { if (r.renderId) byRender[r.renderId] = r; });
          remote.forEach(function (l) { if (l.assetId && l.imageSrc) rendered[l.assetId] = l.imageSrc; });
          var missing = remote.filter(function (l) { return !byRender[l.id]; });
          return Promise.all(missing.map(function (l) {
            return Promise.all((l.productIds || []).map(function (pid) {
              var id = /^\d+$/.test(String(pid)) ? 'store-' + pid : String(pid);
              return inner.getProduct ? inner.getProduct(id).then(function (p) { return p ? { productId: p.id, title: p.title, brand: p.brand, brandSlug: p.brandSlug || '', price: p.price, assetId: p.assetId, url: p.url || '', officialUrl: p.officialUrl || '', brandOfficialUrl: p.brandOfficialUrl || '' } : null; }, function () { return null; }) : Promise.resolve(null);
            })).then(function (its) {
              return { id: 'gl-r-' + l.id, status: 'ready', createdAt: Date.parse(l.createdAt) || Date.now(), renderId: l.id, assetId: l.assetId, demo: false, aiGenerated: true, saved: false, message: '', items: its.filter(Boolean) };
            });
          })).then(function (extra) {
            return { items: items.concat(extra).sort(function (a, b) { return (b.createdAt || 0) - (a.createdAt || 0); }) };
          });
        });
      },
      // an own generated look ('gl-...') opens in /pages/look?id=: private, owned by the signed-in customer; garments read through getProduct
      getLook: function (id) {
        if (!inner.getLook) return Promise.reject(errorFor(404, {}));
        if (!/^gl-/.test(String(id || ''))) {
          // a look saved from another device is saved here too: the server list is the truth for the "Guardados" state of the page
          return inner.getLook(id).then(function (look) {
            return useLookBackend().then(function (on) {
              if (!on || !look || look.visibility === 'deleted') return look;
              return call('GET', '/favorites').then(function (r) {
                var has = ((r && r.favorites) || []).some(function (x) { return x.kind === 'look' && x.id === String(id); });
                return has === !!look.saved ? look : Object.assign({}, look, { saved: has, saves: typeof look.saves === 'number' ? Math.max(0, look.saves + (has ? 1 : -1)) : look.saves });
              }, function () { return look; });
            });
          });
        }
        return real.listGeneratedLooks().then(function (r) {
          var g = ((r && r.items) || []).filter(function (x) { return x.id === id || (x.renderId && 'gl-r-' + x.renderId === id); })[0];
          if (!g || g.status !== 'ready') return inner.getLook(id);
          return Promise.all((g.items || []).map(function (it) {
            return (inner.getProduct ? inner.getProduct(it.productId).catch(function () { return null; }) : Promise.resolve(null)).then(function (p) {
              return Object.assign({ id: it.productId, title: it.title, brand: it.brand, price: it.price, colors: [], favorite: false, assetId: it.assetId }, p || {}, { available: true, soldOut: false, colorNames: [], withdrawn: false });
            });
          })).then(function (products) {
            var me_ = isMember() ? me() : { id: '', displayName: '' };
            return { id: g.id, title: lookName(products[0] && products[0].title, products.length, 'Look del ' + lookDate(g.createdAt)), author: '', authorName: me_.displayName, authorAvatarAssetId: null, ownerId: me_.id, visibility: 'private', description: '', tags: [], location: '', likes: 0, liked: false, saved: false, saves: 0, commentCount: 0, assetId: g.assetId, images: [g.assetId], aiGenerated: true, garmentCount: products.length, createdAt: new Date(g.createdAt || Date.now()).toISOString(), products: products };
          });
        });
      },
      // a look is saved on the server first (so a refused save rolls back in the screen), then mirrored in the inner gateway the screens read
      setLookSaved: function (input) {
        return setLookOnServer(input && input.lookId, input && input.value, null).then(function () { return inner.setLookSaved(input); });
      },
      setSalonLookSaved: function (input) {
        if (!inner.setSalonLookSaved) return Promise.reject(errorFor(404, {}));
        return inner.setSalonLookSaved(input).then(function (r) {
          return setLookOnServer(r && r.id, !!(input && input.value), { title: input.title, productIds: input.productIds, savedAt: input.savedAt }).then(function () { return r; }, function (err) {
            // the server refused it: the local copy goes back as it was, the save never half-happens
            return inner.setSalonLookSaved(Object.assign({}, input, { value: !input.value })).then(function () { throw err; }, function () { throw err; });
          });
        });
      },
      // ---- Fase B ----
      setFavorite: function (input) {
        if (input && input.entity === 'look') return setLookOnServer(input.id, input.value, null).then(function () { return inner.setFavorite(input); });
        if (!input || input.entity !== 'product') return inner.setFavorite(input);
        return useBackend('favorites').then(function (on) {
          return on ? call('POST', '/favorites', { kind: 'product', id: bareId(input.id), value: !!input.value }).then(function () { return null; }) : inner.setFavorite(input);
        });
      },
      listFavorites: function (input) {
        if (input && input.kind === 'look' && isMember()) {
          return useLookBackend().then(function (on) {
            if (on) return serverLooks(input);
            // the seeded examples (@aura.style_, @nico.wears) are not theirs: only looks they made or saved from their own salon
            return inner.listFavorites(input).then(function (r) {
              var items = ((r && r.items) || []).filter(function (l) { return l && (l.source === 'salon' || l.aiGenerated); }), size = (r && r.pageSize) || 12;
              return { items: items.slice(0, size), page: 1, pageSize: size, total: items.length };
            });
          });
        }
        if (!input || input.kind !== 'product') return inner.listFavorites(input);
        return useBackend('favorites').then(function (on) {
          if (!on) return inner.listFavorites(input);
          return migrateLocalFavorites(inner).then(function () { return call('GET', '/favorites'); }).then(function (r) {
            var ids = ((r && r.favorites) || []).filter(function (f) { return f.kind === 'product'; }).map(function (f) { return themeId(f.id); });
            return Promise.all(ids.map(function (id) { return inner.getProduct ? inner.getProduct(id).catch(function () { return null; }) : Promise.resolve(null); })).then(function (list) {
              var items = list.filter(Boolean), size = 12, pg = Math.max(1, (input && input.page) || 1);
              return { items: items.slice((pg - 1) * size, pg * size), page: pg, pageSize: size, total: items.length };
            });
          });
        });
      },
      // history = looks generated in the last 30 days (GET /renders) + garments saved as favourites; no history route of its own
      getHistory: function (input) {
        if (isVisitor()) return inner.getHistory(input);
        if (isMember()) {
          return Promise.all([call('GET', '/renders').catch(function () { return { looks: [] }; }), useBackend('favorites').then(function (on) { return on ? call('GET', '/favorites').catch(function () { return { favorites: [] }; }) : { favorites: [] }; })]).then(function (res) {
            // only garments are history rows: saved looks (kind 'look') share /favorites and are not «Prenda en favoritos»
            var favs = ((res[1] && res[1].favorites) || []).filter(function (f) { return f.kind === 'product'; });
            var lookList = (res[0] && res[0].looks) || [];
            return Promise.all([Promise.all(favs.map(function (f) { return inner.getProduct ? inner.getProduct(themeId(f.id)).then(function (p) { return p || {}; }, function () { return {}; }) : Promise.resolve({}); })), Promise.all(lookList.map(function (l) { var pid = (l.productIds || [])[0]; return pid && inner.getProduct ? inner.getProduct(themeId(pid)).then(function (p) { return p || null; }, function () { return null; }) : Promise.resolve(null); }))]).then(function (both) {
            var prods = both[0], lfirst = both[1];
            ((res[0] && res[0].looks) || []).forEach(function (l) { if (l.assetId && l.imageSrc) rendered[l.assetId] = l.imageSrc; });
            var rows = ((res[0] && res[0].looks) || []).map(function (l, li) { return { id: 'h-' + l.id, kind: 'look', typeLabel: 'Look creado', title: lookName(lfirst[li] && lfirst[li].title, (l.productIds || []).length, 'Look del ' + String(l.createdAt).slice(0, 10)), at: l.createdAt, entityId: 'gl-r-' + l.id, assetId: l.assetId || null }; })
              .concat(favs.map(function (f, i) { return { id: 'hf-' + f.id, kind: 'garment', typeLabel: 'Prenda en favoritos', title: (prods[i] && prods[i].title) || 'Prenda guardada', at: f.createdAt, entityId: themeId(f.id), assetId: (prods[i] && prods[i].assetId) || null }; }));
            rows.sort(function (a, b) { return (input && input.order === 'oldest' ? 1 : -1) * (Date.parse(a.at) - Date.parse(b.at)); });
            if (input && input.type) rows = rows.filter(function (r) { return r.kind === input.type; });
            var size = 12, pg = Math.max(1, (input && input.page) || 1);
            return { items: rows.slice((pg - 1) * size, pg * size), page: pg, pageSize: size, total: rows.length };
            });
          });
        }
        return inner.getHistory(input);
      },
      // Centro de avisos (docs/normcore-centro-avisos.md): del backend solo con /config features.notifications y sesión; sin eso `unavailable` y NINGUNA petición a /notifications.
      // ?nc-notices=mock lee el mock determinista (revisión de diseño, como ?nc-scenario): no toca el backend.
      listNotifications: function () {
        if (noticesMock()) return inner.listNotifications().then(function (r) { // the mock's fixed dates move to "now" so the preview reads as live
          var delta = Date.now() - Date.parse(r.base || 0), shift = function (v) { return typeof v === 'string' && !isNaN(Date.parse(v)) ? new Date(Date.parse(v) + delta).toISOString() : v; };
          r.notifications.forEach(function (n) { n.createdAt = shift(n.createdAt); if (n.payload) { n.payload.executeAfter = shift(n.payload.executeAfter); n.payload.at = shift(n.payload.at); } });
          return r;
        });
        return useBackend('notifications').then(function (on) {
          if (!on) return { unavailable: true, notifications: [], unread: 0 };
          return call('GET', '/notifications').then(function (r) { return { notifications: (r && r.notifications) || [], unread: (r && r.unread) || 0 }; });
        });
      },
      markNotificationsRead: function (input) {
        if (noticesMock()) return inner.markNotificationsRead(input);
        return useBackend('notifications').then(function (on) {
          if (!on) return { unread: 0 };
          return call('POST', '/notifications/read', input && input.all ? { all: true } : { ids: (input && input.ids) || [] });
        });
      },
      // Extra notice actions (docs/normcore-centro-avisos-acciones.md): only with /config features.notificationsDelete / notificationsUnread, so the theme can ship before the routes exist.
      noticeActions: function () {
        if (noticesMock()) return Promise.resolve({ del: true, unread: true });
        return features().then(function (f) { return { del: !!f.notificationsDelete, unread: !!f.notificationsUnread }; });
      },
      deleteNotifications: function (input) {
        if (noticesMock()) return inner.deleteNotifications(input);
        return useBackend('notificationsDelete').then(function (on) {
          if (!on) throw errorFor(404, {});
          return call('DELETE', '/notifications', input && input.read ? { read: true } : { ids: (input && input.ids) || [] });
        });
      },
      getAccountStatus: function () { return useBackend('account').then(function (on) { return on ? call('GET', '/account') : { deletion: { state: 'none' }, unavailable: true }; }); },
      requestAccountDeletion: function () { return call('POST', '/account/deletion'); },
      cancelAccountDeletion: function () { return call('DELETE', '/account/deletion'); },
      exportAccountData: function () { return call('GET', '/account/export'); },
      getAsset: function (assetId) {
        if (rendered[assetId]) return cutout(rendered[assetId]).then(function (src) { return { id: assetId, assetId: assetId, src: src, width: null, height: null, sha256: null, owner: 'UNKNOWN', license: 'UNKNOWN', alt: '', crop: null, placeholder: false, aiGenerated: true }; });
        return inner.getAsset ? inner.getAsset(assetId) : Promise.resolve(null);
      }
    };
    var out = Object.create(inner);
    Object.keys(real).forEach(function (k) { out[k] = real[k]; });
    return out;
  }
  root.NcGatewayTryon = { wrap: wrap, BASE: BASE, keyOut: keyOut, cutout: cutout, errorFor: errorFor, kindFor: kindFor, authFromPage: authFromPage };
})(typeof window !== 'undefined' ? window : this);
